import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Cairo', 'Roboto', sans-serif;
    background-color: #f8f8f8;
    color: #333;
    direction: rtl;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }

  .section {
    padding: 60px 0;
  }

  .section-title {
    text-align: center;
    margin-bottom: 40px;
    color: #2e7d32;
    font-size: 2.5rem;
  }

  .btn {
    display: inline-block;
    padding: 10px 20px;
    background-color: #2e7d32;
    color: white;
    border-radius: 5px;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: #1b5e20;
      transform: translateY(-2px);
    }
  }
`;

export default GlobalStyles;
